var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddFamilyTemplate',{attrs:{"header":_vm.header,"internal":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('FamilyReporter',{ref:"form"})]},proxy:true},{key:"actions",fn:function(){return [_c('FamilyReporterButtons',{on:{"validate":_vm.validateData}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }